export default __webpack_public_path__ + "static/media/spinner.d8343f79.svg";